import { saveInLocal } from 'src/service/helpers';
import { CustomerSearchActionTypes, CustomerSearchState, CustomerSearchAction } from './types';

const initialState: CustomerSearchState = {
  customers: [],
  aceCustomers: [],
};

export const customerSearchReducer = (
  state: CustomerSearchState = initialState,
  action: CustomerSearchActionTypes,
): CustomerSearchState => {
  switch (action.type) {
    case CustomerSearchAction.SET_CUSTOMERS: {
      saveInLocal('state', JSON.stringify(action?.payload || []));
      return {
        ...state,
        customers: action.payload,
      };
    }
    case CustomerSearchAction.SET_ACE_CUSTOMERS: {
      saveInLocal('aceCustomers', JSON.stringify(action.payload));
      return {
        ...state,
        aceCustomers: action.payload,
      };
    }

    default:
      return state;
  }
};
